import React, { useState, useEffect } from "react";
import AddIcon from "../../../assets/Icons/add person icon.svg";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import CustomAlert from "../../../helpers/CustomAlert";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import { apiList } from "../../../helpers/apiList";
import { axiosGetApi, axiosPostApi } from "../../../helpers/interceptorServices";
import confetti from "canvas-confetti";
import Dropdown from "../../../components/Dropdown";

const DeliveryBoyDetailModal = ({
  show,
  handleClose,
  editData,
  action,
  fetchDeliveryBoyData,
  callApi,
}) => {
  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    fullName: "",
    id: "",
    contactNumber: "",
    alternateContactNumber: "",
    email: "",
    availability: "ACTIVE",
    parentType: "",
    parentCode:"",
  });

  const [errors, setErrors] = useState({});
  const [hubList, setHubList] = useState([]);
  const [lmbpList, setLmbpList] = useState([]);

  useEffect(() => {
    if (action === "modify" || action === "view") {
      setFormData({
        fullName: editData?.fullName || "",
        id: editData?.id || "",
        contactNumber: editData?.mobileNo || "",
        alternateContactNumber: editData?.alternateMobileNo || "",
        email: editData?.email || "",
        availability: editData?.status || "ACTIVE",
        parentType: editData?.parentType,
        parentCode: editData?.parentCode || "",
      });
    } else if (action === "add") {
      setFormData({
        fullName: "",
        id: "",
        contactNumber: "",
        alternateContactNumber: "",
        email: "",
        availability: "ACTIVE",
        parentType:"",
        parentCode:"",
      });
      setErrors({});
    }
  }, [editData, action]);

  useEffect(() => {
    if (formData?.parentType === "HUB") {
      setLmbpList([]);
      fetchActiveHUBData();
    } else if (formData?.parentType === "LMBP") {
      setHubList([]);
      fetchActiveLmbpData();
    }
  },[formData?.parentType]);

    const fetchActiveLmbpData = async () => {
        // setApiLoading(true);
        try {
          const response = await axiosGetApi(
            `${apiList.FETCH_ALL_MASTER_LMBP_LIST}?username=${loggedInUserName}`,
          );
    
          if (response?.status === 200) {
            setLmbpList(response?.data?.data);
            // setApiLoading(false);
          }
        } catch (error) {
          console.error("Error fetching LMBP data:", error);
          // setApiLoading(false);
        } finally {
          // setApiLoading(false);
        }
    };

    const fetchActiveHUBData = async () => {
        // setApiLoading(true);
        try {
          const response = await axiosGetApi(
            `${apiList.ALL_ACTIVE_HUB_DATA}?username=${loggedInUserName}`,
          );
    
          if (response?.status === 200) {
            setHubList(response?.data?.data);
            // setApiLoading(false);
          }
        } catch (error) {
          console.error("Error fetching HUB data:", error);
          // setApiLoading(false);
        } finally {
          // setApiLoading(false);
        }
    };

  // ✅ Validate individual fields
  const validateField = (id, value) => {
    let message = "";

    switch (id) {
      case "fullName":
        if (!value.trim()) {
          message = "Full Name is required";
        } else if (value.trim().length < 2) {
          message = "Full Name must be at least 2 characters long";
        } else if (!/^[A-Za-z ]+$/.test(value)) {
          message = "Full Name must contain only letters and spaces";
        }
        break;

      case "contactNumber":
        if (!value.trim()) {
          message = "Contact Number is required";
        } else if (!/^[6789]\d{9}$/.test(value)) {
          message = "Contact Number must be 10 digits starting with 6,7,8,9";
        } else if (/^(\d)\1{9}$/.test(value)) {
          message =
            "Contact Number cannot have all digits the same (e.g., 9999999999)";
        }
        break;

      case "alternateContactNumber":
        if (value.trim() && !/^[6789]\d{9}$/.test(value)) {
          message =
            "Alternate Contact Number must be 10 digits starting with 6,7,8,9";
        } else if (value.trim() && /^(\d)\1{9}$/.test(value)) {
          message =
            "Alternate Contact Number cannot have all digits the same (e.g., 8888888888)";
        }
        break;

      case "email":
        if (!value.trim()) {
          message = "Email is required";
        } else if (
          !/^[\w.-]+@[a-zA-Z\d.-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(value)
        ) {
          message = "Enter valid email ending with .com, .in, .pe, or .co.xx";
        }
        break;

      case "availability":
        if (!value) {
          message = "Availability is required";
        }
        break;

      case "parentType":
        if (!value.trim()) {
          message = "Parent Type is required";
        }
        break;

      case "parentCode":
        if (!value.trim()) {
          message = "Parent Code is required";
        }

      default:
        break;
    }

    return message;
  };

  // ✅ Validate all fields
  const validate = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key === "alternateContactNumber" && !formData[key].trim()) {
        return;
      }
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    return newErrors;
  };

  // ✅ Handle input change with validation + digit restriction
  const handleChange = (e) => {
    const { id, value } = e.target;
    let newValue = value;

    // Allow only digits and max length 10 for phone numbers
    if (id === "contactNumber" || id === "alternateContactNumber") {
      newValue = newValue.replace(/\D/g, "").slice(0, 10);
    }

    const updatedForm = { ...formData, [id]: newValue };
    setFormData(updatedForm);

    // Live validation
    const errorMessage = validateField(id, newValue);
    setErrors((prev) => ({ ...prev, [id]: errorMessage }));
  };

  // ✅ Handle onBlur validation
  const handleBlur = (e) => {
    const { id, value } = e.target;
    const errorMessage = validateField(id, value);
    setErrors((prev) => ({ ...prev, [id]: errorMessage }));
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    console.log("::validationErrors::", validationErrors);

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const validationErrors = validate();
      setErrors(validationErrors);

      if (Object.keys(validationErrors).length === 0) {
        let apiUrl = "";
        let successMessage = "";

        if (action === "add") {
          apiUrl = apiList.CREATE_DELIVERY_BOY;
          successMessage = "Delivery boy added successfully";
        } else if (action === "modify") {
          apiUrl = apiList.MODIFY_DELIVERY_BOY;
          successMessage = "Delivery boy details modified successfully";
        }

        const payload = {
          username: loggedInUserName,
          fullName: formData?.fullName,
          mobileNo: formData?.contactNumber,
          email: formData?.email,
          status: formData.availability,
          parentType: formData.parentType,
          parentCode: formData.parentCode,
          ...(action === "modify" ? { id: formData.id } : {}),
          ...(formData.alternateContactNumber?.trim()
            ? { alternateMobileNo: formData.alternateContactNumber }
            : {}),
        };

        axiosPostApi(apiUrl, payload)
          .then((response) => {
            if (response?.status === 200 && response?.data?.status === true) {
              CustomAlert({
                title: "Success",
                text: response?.data?.message || "User Added Successfully",
                icon: "success",
                confirmButtonText: "Ok",
              });
              const canvas = document.createElement("canvas");
              canvas.style.position = "fixed";
              canvas.style.top = "0";
              canvas.style.left = "0";
              canvas.style.width = "100%";
              canvas.style.height = "100%";
              canvas.style.zIndex = "3000";
              document.body.appendChild(canvas);

              const confettiInstance = confetti.create(canvas, {
                resize: true,
                useWorker: true,
              });

              confettiInstance({
                particleCount: 250,
                spread: 100,
                origin: { y: 0.6 },
              });

              setTimeout(() => {
                document.body.removeChild(canvas);
              }, 3000);
              handleClose();
              callApi(1);
            } else {
              CustomAlert({
                title:
                  action === "add"
                    ? "Failed to Add User"
                    : "Failed to Modify User",
                text:
                  response.data.message ||
                  "There was an issue processing the request. Please try again.",
                icon: "error",
                confirmButtonText: "Retry",
              });
            }
          })
          .catch((error) => {
            console.error("Error processing request:", error);
            CustomAlert({
              title: "Error",
              text:
                action === "add"
                  ? "An error occurred while adding the user. Please try again later."
                  : "An error occurred while modifying the user. Please try again later.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          });
      }
    }
  };

  const parentTypeOptions = [
    { label: "HUB", value: "HUB" },
    { label: "LMBP", value: "LMBP" },
  ];

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{
          display: show ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content w-[600px] rounded-3xl shadow-lg">
            {/* Header */}

            <div className="rounded-[23px]">
              {/* <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              /> */}
              <div className="modal-header justify-between flex px-6 py-3">
                <div className="flex items-center gap-4">
                  <img src={AddIcon} alt="icon" className="w-10 h-10" />
                  <h5 className="modal-title main-title m-0 font-semibold">
                    {action.charAt(0).toUpperCase() + action.slice(1)} Delivery
                    Boy
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close"
                  className="w-[30px] h-[30px] cursor-pointer"
                  onClick={handleClose}
                />
              </div>
            </div>

            {/* Body */}
            <form>
              <div className="modal-body px-6 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-5">
                  {/* Full Name */}
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <i className="fa fa-user absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                      <input
                        type="text"
                        id="fullName"
                        placeholder="Full Name"
                        value={formData.fullName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                        className={`w-full h-[42px] rounded-lg border border-gray-300 pl-10 pr-3 text-sm placeholder-gray-400
                          focus:outline-none focus:ring-0 focus:border-[#FF702B]
                          ${
                            isViewMode || isDeleteMode
                              ? "bg-gray-100 cursor-not-allowed"
                              : "bg-white"
                          }`}
                      />
                    </div>
                    {errors.fullName && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.fullName}
                      </p>
                    )}
                  </div>

                  {/* Contact Number */}
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Contact Number <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <i className="fa fa-phone absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                      <input
                        type="text"
                        id="contactNumber"
                        placeholder="Contact Number"
                        value={formData.contactNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                        className={`w-full h-[42px] rounded-lg border border-gray-300 pl-10 pr-3 text-sm placeholder-gray-400
                          focus:outline-none focus:ring-0 focus:border-[#FF702B]
                          ${
                            isViewMode || isDeleteMode
                              ? "bg-gray-100 cursor-not-allowed"
                              : "bg-white"
                          }`}
                      />
                    </div>
                    {errors.contactNumber && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.contactNumber}
                      </p>
                    )}
                  </div>

                  {/* Alternate Contact Number */}
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Alternate Contact Number
                    </label>
                    <div className="relative">
                      <i className="fa fa-mobile-alt absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                      <input
                        type="text"
                        id="alternateContactNumber"
                        placeholder="Alternate Contact Number"
                        value={formData.alternateContactNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                        className={`w-full h-[42px] rounded-lg border border-gray-300 pl-10 pr-3 text-sm placeholder-gray-400
                          focus:outline-none focus:ring-0 focus:border-[#FF702B]
                          ${
                            isViewMode || isDeleteMode
                              ? "bg-gray-100 cursor-not-allowed"
                              : "bg-white"
                          }`}
                      />
                    </div>
                    {errors.alternateContactNumber && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.alternateContactNumber}
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <i className="fa fa-envelope absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                      <input
                        type="email"
                        id="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                        className={`w-full h-[42px] rounded-lg border border-gray-300 pl-10 pr-3 text-sm placeholder-gray-400
                          focus:outline-none focus:ring-0 focus:border-[#FF702B]
                          ${
                            isViewMode || isDeleteMode
                              ? "bg-gray-100 cursor-not-allowed"
                              : "bg-white"
                          }`}
                      />
                    </div>
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Availability */}
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Availability <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <i className="fa fa-toggle-on absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                      <select
                        id="availability"
                        value={formData.availability || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                        className={`w-full h-[42px] rounded-lg border border-gray-300 pl-10 pr-3 text-sm
                          focus:outline-none focus:ring-0 focus:border-[#FF702B]
                          ${
                            isViewMode || isDeleteMode
                              ? "bg-gray-100 cursor-not-allowed"
                              : "bg-white"
                          }`}
                      >
                        <option value="">Select Availability</option>
                        <option value="ACTIVE">Active</option>
                        <option value="IN-ACTIVE">Inactive</option>
                      </select>
                    </div>
                    {!(isViewMode || isDeleteMode) && errors.availability && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.availability}
                      </p>
                    )}
                  </div>

                  {/* Parent Type */}
                  <div>
                    <label 
                      className="text-sm font-medium text-gray-700 mb-1 block"
                      htmlFor="parentType"
                    >
                      Parent Type
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Dropdown
                      options={parentTypeOptions}
                      value={formData.parentType}
                      labelKey="label"
                      valueKey="value"
                      placeholder="Select Parent Type"
                      onChange={(item) => {
                    
                        handleChange({
                          target: {
                            id: "parentType",
                            value: item.value,
                          },
                        });
                      }}
                      disabled={isViewMode || isDeleteMode}
                      error={errors.parentType}
                    />
                  </div>

                  {formData?.parentType === "HUB" ? (
                    <>
                      <div>
                        <label 
                          htmlFor="parentCode" 
                          className="text-sm font-medium text-gray-700 mb-1 block"
                        >
                          HUB List
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Dropdown
                          options={hubList}
                          value={formData.parentCode}
                          placeholder="Select HUB"
                          onChange={(item) =>
                            handleChange({
                              target: {
                                id: "parentCode",
                                value: item.hubCode,
                              },
                            })
                          }
                          labelKey="hubName"
                          valueKey="hubCode"
                          disabled={isViewMode || isDeleteMode}
                          error={errors.parentCode}
                        />
                      </div>
                    </>
                  ) : formData?.parentType === "LMBP" ? (
                    <>
                    <div>
                      <label 
                        htmlFor="parentCode" 
                        className="text-sm font-medium text-gray-700 mb-1 block"
                      >
                        LMBP List
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Dropdown
                        options={lmbpList}
                        value={formData.parentCode}
                        placeholder="Select LMBP"
                        onChange={(item) =>
                          handleChange({
                            target: {
                              id: "parentCode",
                              value: item.customerCode,
                            },
                          })
                        }
                        labelKey="name"
                        valueKey="customerCode"
                        disabled={isViewMode || isDeleteMode}
                        error={errors.parentCode}
                      />
                    </div>
                    </>
                  ) : null}
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="scoped-modal modal-footer justify-center border-t-0">
                <button
                  type="button"
                  className="btn btn-back w-[133px] !rounded-lg"
                  onClick={handleClose}
                >
                  Back
                </button>
                {!isViewMode && !isDeleteMode && (
                  <div
                    className="btn btn-submit w-[133px] !rounded-lg"
                    onClick={handleSubmit}
                  >
                    {isEditMode ? "Update" : "Submit"}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default DeliveryBoyDetailModal;
